import { MenuRoot, MenuContent, ButtonIcon, MenuTrigger } from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

import {
  PlanningBacklogAddChallengeButton,
  PlanningBacklogAddLibraryChallengeButton,
} from 'features/planning';

export const PlanningBacklogHeaderMenu = () => (
  <MenuRoot>
    <MenuTrigger asChild>
      <ButtonIcon
        aria-label="Options"
        data-testid="backlog-header-add"
        variant="ghost"
      >
        <Icon
          name={iconNames.plus}
          height="10px"
          width="10px"
          strokeWidth={2}
        />
      </ButtonIcon>
    </MenuTrigger>
    <MenuContent>
      <PlanningBacklogAddChallengeButton key="add-challenge" />
      <PlanningBacklogAddLibraryChallengeButton key="add-library-challenge" />
    </MenuContent>
  </MenuRoot>
);
